import { combineReducers } from 'redux';
import createDux from './lib/createDux';
import detailsDux from './lib/detailsDux';

const { reducer: $shippingBillIndia, actions: shippingBillIndia, epics: shippingBillIndiaEpics } = createDux({
  name: 'pdfReader.shippingBillIndia',
  url: '/api/pdfReader/shippingBillIndia',
  headers: { 'Content-Type': 'FormData' },
});

const { reducer: $billOfLading, actions: billOfLading, epics: billOfLadingEpics } = createDux({
  name: 'pdfReader.billOfLading',
  url: '/api/pdfReader/billOfLading',
  headers: { 'Content-Type': 'FormData' },
});

const { reducer: $invoiceCreate, actions: invoiceCreate, epics: invoiceCreateEpics } = createDux({
  name: 'pdfReader.invoice',
  url: '/api/pdfReader/createInvoice',
  headers: { 'Content-Type': 'FormData' },
});

const { reducer: $invoiceDetails, actions: invoiceDetails, epics: invoiceDetailsEpics } = detailsDux({
  name: 'pdfReader.invoice',
  url: '/api/pdfReader/getInvoice',
});

const { reducer: $quoteCreate, actions: quoteCreate, epics: quoteCreateEpics } = createDux({
  name: 'pdfReader.quote',
  url: '/api/pdfReader/quotes',
  headers: { 'Content-Type': 'FormData' },
});

const { reducer: $quoteDetails, actions: quoteDetails, epics: quoteDetailsEpics } = detailsDux({
  name: 'pdfReader.quote',
  url: '/api/pdfReader/quotes',
});

const { reducer: $invoiceQuoteChargesMappingCreate, actions: invoiceQuoteChargesMappingCreate, epics: invoiceQuoteChargesMappingCreateEpics } = createDux({
  name: 'pdfReader.invoiceQuoteChargesMapping',
  url: '/api/pdfReader/invoiceQuoteChargesMapping',
});

const { reducer: $invoiceQuoteChargesMappingDetails, actions: invoiceQuoteChargesMappingDetails, epics: invoiceQuoteChargesMappingDetailsEpics } = detailsDux({
  name: 'pdfReader.invoiceQuoteChargesMapping',
  url: '/api/pdfReader/invoiceQuoteChargesMapping',
});

export const actions = { shippingBillIndia, billOfLading, invoiceCreate, invoiceDetails, quoteCreate, quoteDetails, invoiceQuoteChargesMappingCreate, invoiceQuoteChargesMappingDetails };
export const epics = [...shippingBillIndiaEpics, ...billOfLadingEpics, ...invoiceCreateEpics, ...invoiceDetailsEpics, ...quoteDetailsEpics, ...quoteCreateEpics, ...invoiceQuoteChargesMappingCreateEpics, ...invoiceQuoteChargesMappingDetailsEpics];
export default combineReducers({ $shippingBillIndia, $billOfLading, $invoiceCreate, $invoiceDetails, $quoteCreate, $quoteDetails, $invoiceQuoteChargesMappingCreate, $invoiceQuoteChargesMappingDetails });